import { ContractorType } from './ContractorType'
import { Franchise } from './Franchise'
import { ValidFrom } from './ValidFrom'

export const MainStep = () => {
  return (
    <>
      <ContractorType />
      <ValidFrom />
      <Franchise />
    </>
  )
}
